<template>
	<span :class="classes" data-testid="badge">
		<slot></slot>
	</span>
</template>

<script setup lang="ts">
	import { computed } from 'vue'

	const props = withDefaults(
		defineProps<{
			size?: 'small' | 'medium' | 'large'
			theme?:
				| 'primary'
				| 'secondary'
				| 'success'
				| 'info'
				| 'warning'
				| 'danger'
				| 'neutral'
				| 'outline'
			rounded?: boolean
		}>(),
		{
			size: 'small',
			theme: 'primary',
			rounded: false
		}
	)

	const classes = computed(() => ({
		'inline-flex items-center font-medium ring-1 ring-inset': true,
		'bg-mabey-50 text-mabey-600 ring-mabey-500/10': props.theme == 'primary',
		'bg-cyan-50 text-cyan-600 ring-cyan-500/10': props.theme == 'secondary',
		'bg-green-50 text-green-600 ring-green-500/10': props.theme == 'success',
		'bg-blue-50 text-blue-600 ring-blue-500/10': props.theme == 'info',
		'bg-yellow-50 text-yellow-600 ring-yellow-500/10': props.theme == 'warning',
		'bg-red-50 text-red-600 ring-red-500/10': props.theme == 'danger',
		'bg-pink-100 text-pink-600 ring-pink-500/10': props.theme == 'neutral',
		'bg-gray-50 text-gray-600 ring-gray-500/10': props.theme == 'outline',
		'rounded-md': !props.rounded,
		'rounded-full': props.rounded,
		'px-3 py-2 text-md': props.size === 'large',
		'px-2.5 py-2 text-sm leading-tight': props.size == 'medium',
		'px-2 py-1 text-xs': props.size === 'small'
	}))
</script>
